export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'Categoria',
                    type: 'custom-html',
                    key: 'type',
                    modifier: (item) => {
                        return item == 'NC' ? 'No Conformidad' : 'Comentario';
                    }
                },
                {
                    title: 'Obligatorio',
                    type: 'custom-html',
                    key: 'type',
                    modifier: (item) => {
                        let ClassName = 'info';
                        let state = 'NO';
                        if (item == 'NC') ClassName = `danger`, state = 'SI';
                        return `<span class="badge badge-sm badge-pill badge-${ClassName}">${state}</span>`;
                    }
                },
                {
                    title: 'Requisito',
                    type: 'text',
                    key: 'requirement',
                },
                {
                    title: 'Hallazgo',
                    type: 'text',
                    key: 'finding',
                },
                {
                    title: 'Evidencia',
                    type: 'text',
                    key: 'evidence',
                },
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}